export const CLEAR_DRAWER_STATE = 'CLEAR_DRAWER_STATE';
export const SET_DRAWER_OPEN_STATE = 'SET_DRAWER_OPEN_STATE';
export function clearDrawerState() {
    return {
        type: CLEAR_DRAWER_STATE
    };
}
export function setDrawerOpenState(isOpen) {
    return {
        type: SET_DRAWER_OPEN_STATE,
        payload: isOpen
    };
}
